import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5 relative overflow-hidden" data-id="element-422">
      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-423">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-424">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight text-white" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-425">
            Presentamos el{' '}
            <span className="text-[#eab308]" data-id="element-426">Sistema Maestría Reiki</span>
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-427">
            <p data-id="element-428">
              La formación más completa en Reiki en español — en formato
              digital, a tu ritmo, con todo lo que necesitás para empezar,
              profundizar y profesionalizarte.
            </p>

            <p className="text-white font-medium" data-id="element-429">
              No es un curso de fin de semana.
            </p>

            <p className="text-white font-medium" data-id="element-430">
              No es un PDF genérico con información que podés googlear.
            </p>

            <p data-id="element-431">
              Es un sistema de 6 tomos que te lleva de cero a Maestro/a — con
              protocolos reales, símbolos sagrados, técnicas avanzadas y todo lo
              que necesitás para practicar con confianza y, si querés, cobrar
              por lo que sabés.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4" data-id="element-432">
            <span className="bg-white/5 border border-white/20 rounded-full px-5 py-2 text-white font-medium text-sm md:text-base backdrop-blur-sm" data-id="element-433">
              📱 100% Digital
            </span>
            <span className="bg-white/5 border border-white/20 rounded-full px-5 py-2 text-white font-medium text-sm md:text-base backdrop-blur-sm" data-id="element-434">
              ⏰ A tu ritmo
            </span>
            <span className="bg-white/5 border border-white/20 rounded-full px-5 py-2 text-white font-medium text-sm md:text-base backdrop-blur-sm" data-id="element-435">
              ♾️ Acceso de por vida
            </span>
          </div>
        </div>
      </div>
    </section>;
}